"use strict";
/*
 * Created on 6. 3. 2020
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Representation of one day baseline of single window item after window the item belongs to finishes. The values is sum of product
 * baselines at sites of the window item.
 * Baseline for days in window validity period is stored in WindowItemForecastSite class
 * @author Stepan Mik
 * @see DayStockLeft KPI
 */


var WindowItemPostBaseline =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemPostBaseline, _DomainObject_1$Domai);

  function WindowItemPostBaseline(id, windowItemId, windowId, //to allow block deletion
  date, amount) {
    var _this;

    _classCallCheck(this, WindowItemPostBaseline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPostBaseline).call(this));
    _this.id = id;
    _this.windowItemId = windowItemId;
    _this.windowId = windowId;
    _this.date = date;
    _this.amount = amount;
    return _this;
  }

  return WindowItemPostBaseline;
}(DomainObject_1.DomainObject);

exports.WindowItemPostBaseline = WindowItemPostBaseline;
WindowItemPostBaseline.maxSupplyDaysLeft = 14;
WindowItemPostBaseline.daysAfterEnd = 7 + WindowItemPostBaseline.maxSupplyDaysLeft;

WindowItemPostBaseline.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(WindowItemPostBaseline.name);
  return {
    id: bld.id('id'),
    windowItemId: bld.id('windowItemId'),
    windowId: bld.id('windowId'),
    date: bld.date('date'),
    amount: bld.bigNum('amount')
  };
}();